export default __webpack_public_path__ + "static/media/acp-icon.5e322701.svg";